/* eslint-disable graphql/template-strings */
import React from 'react';
// graphQL
import gql from 'graphql-tag';
// global variables
import { localStorageAuthKey as AUTH_TOKEN } from 'config';
// our components
import { DASHBOARD } from 'routes/paths';
import RouterContext from 'helpers/routerContext';
import { Mutation } from 'components/common/Query';
import UserLogin from './Login';

/**
 * Mutation to login
 */
export const LOGIN_MUTATION = gql`
  mutation($username: String!, $password: String!) {
    login(input: { username: $username, password: $password }) {
      user {
        id
        email
        fullname
        changePassOnLogin
      }
      token
      errors {
        field
        messages
      }
    }
  }
`;

/**
 * @class
 * @extends Component
 */
class UserLoginContainer extends React.Component {
  static contextType = RouterContext;

  constructor(props) {
    super(props);
    this.state = {
      errors: [],
    };
  }

  /**
   * @description
   * Mutation callback when login is completed.
   *
   * @param {Object} login - Mutation result.
   */
  loginCompleted = async ({ login }) => {
    const history = this.context;
    const { token, errors } = login;
    if (errors) {
      this.setState({ errors });
    } else {
      this.saveToken(token);
      history.push(DASHBOARD);
    }
  };

  /**
   * @description
   * Save token in localStorage after login.
   *
   * @param {Object} token - Token to save.
   */
  saveToken = token => {
    localStorage.setItem(AUTH_TOKEN, token);
  };

  /**
   * @description
   * Render UserLogin component
   */
  render() {
    const { errors } = this.state;
    return (
      <Mutation mutation={LOGIN_MUTATION} onCompleted={this.loginCompleted}>
        {login => (
          <UserLogin
            login={data => login({ variables: data })}
            errors={errors}
            {...this.props}
          />
        )}
      </Mutation>
    );
  }
}

export default UserLoginContainer;
